//
// countup.js
// Theme module
//
// Confetti
// https://github.com/catdad/canvas-confetti

import { CountUp } from 'countup.js';
import confetti from 'canvas-confetti';

// Confetti related: Get below elements to determine the page we're on.
// Why? The confetti only loads on the home and success pages, they're configured differently.
// We need to get get these elements up here so we can conditionally trigger the confetti
// on either the homepage or success page.
const $counterContainer = document.querySelectorAll('.counter-container');
const $successContainer = document.querySelectorAll('#success');

const toggles = document.querySelectorAll('[data-countup]');

function init(toggle) {
  const endVal = toggle.dataset.to ? +toggle.dataset.to : null;
  const options = toggle.dataset.countup ? JSON.parse(toggle.dataset.countup) : {};

  const countUp = new CountUp(toggle, endVal, options);

  // countUp.start();

  if ($counterContainer.length > 0) {
    countUp.start(startCounterConfetti);
  } else if ($successContainer.length > 0) {
    countUp.start(startPageConfetti);
  }else{
    countUp.start();
  }
}

toggles.forEach((toggle) => {
  if (toggle.getAttribute('data-aos-id') !== 'countup:in') {
    init(toggle);
  }
});

document.addEventListener('aos:in:countup:in', function (e) {
  const counts =
    e.detail instanceof Element
      ? [e.detail]
      : document.querySelectorAll('.aos-animate[data-aos-id="countup:in"]:not(.counted)');

  counts.forEach((count) => {
    init(count);
  });

});

// Make available globally
window.CountUp = CountUp;


// ===========================
// Confetti homepage Setup

function startCounterConfetti() {

  const canvasCounter = document.getElementById('confetti-counter');
  canvasCounter.confetti = canvasCounter.confetti || confetti.create(canvasCounter, { resize: true });

  // Add a class when the confetti starts
  $counterContainer.forEach(el => el.classList.remove('confetti-none'));
  $counterContainer.forEach(el => el.classList.add('confetti-start'));

  const duration = 3000;
  const animationEnd = Date.now() + duration;
  let skew = 1;

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  (function frame() {
    const timeLeft = animationEnd - Date.now();
    const ticks = 100;
    skew = Math.max(0.8, skew - 0.001);

    canvasCounter.confetti({
      particleCount: 1,
      startVelocity: 0,
      origin: {
        x: Math.random(),
        y: 0
      },
      colors: ['#ffd66f'],
      shapes: ['square'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0, 0.8),
      drift: randomInRange(-0.4, 0.4)
    });

    canvasCounter.confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        y: (Math.random() * skew) - 0.2
      },
      colors: ['#159fd9'],
      shapes: ['square'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0, 0.7),
      drift: randomInRange(-0.4, 0.4)
    });

    canvasCounter.confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        y: (Math.random() * skew) - 0.2
      },
      colors: ['#df4759'],
      shapes: ['circle'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0, 0.6),
      drift: randomInRange(-0.4, 0.4)
    });

    if (timeLeft > 0) {
      requestAnimationFrame(frame);
    } else {
      $counterContainer.forEach(el => el.classList.remove('confetti-start'));
      $counterContainer.forEach(el => el.classList.add('confetti-end'));
    }
  }());
}

// ===========================
// Confetti Success page Setup

function startPageConfetti() {
  const canvasPage = document.getElementById('page-confetti');

  canvasPage.confetti = canvasPage.confetti || confetti.create(canvasPage, { resize: true });

  var duration = 5000;
  var animationEnd = Date.now() + duration;
  var skew = 1;

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  (function frame() {
    var timeLeft = animationEnd - Date.now();
    var ticks = 400;
    skew = Math.max(0.8, skew - 0.001);

    canvasPage.confetti({
      particleCount: 1,
      startVelocity: 0,
      origin: {
        x: Math.random(),
        y: 0
      },
      colors: ['#ffffff'],
      shapes: ['square'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0.5, 1.6),
      drift: randomInRange(-0.4, 0.4)
    });

    canvasPage.confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        y: 0
      },
      colors: ['#159fd9'],
      shapes: ['square'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0.5, 1.4),
      drift: randomInRange(-0.4, 0.4)
    });

    canvasPage.confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        y: 0
      },
      colors: ['#df4759'],
      shapes: ['square'],
      gravity: randomInRange(0.1, 0.6),
      scalar: randomInRange(0.3, 1.6),
      drift: randomInRange(-0.4, 0.4)
    });

    if (timeLeft > 0) {
      requestAnimationFrame(frame);
    }
  }());
}